import Vue from "vue";
import VueRouter from "vue-router";
import FeedView from "../views/FeedView.vue";
import {authGuard} from "../auth/authGuard";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: FeedView,
  },
  {
    path: "/profile",
    name: "Profile",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    beforeEnter: authGuard,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ProfileView.vue"),
  },
  {
    path: "/newpost",
    name: "addNewTrip",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    beforeEnter: authGuard,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CreatePost.vue"),
  },
  {
    path: "/trip/:id",
    name: "trip",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    beforeEnter: authGuard,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Request.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
